/**
 * Created by Claude on 08.04.2026
 */

const AchievementRewardWindow = Prefab.createWindow("achievement_reward_window", "achievementrewardwindow_prefab_json", {
    bundles: ["achievements"],
    openSound: bundles.achievement_reward_window.urls.window_open && { bundleName: "achievement_reward_window", key: "window_open" }
});
